export default {
  googleSearch: false
}
